export default {
  googleSearch: false
}
